module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedThin.022f8c3.woff";